export const TYPE_KAPHA = 'KAPHA';
export const TYPE_PITTA = 'PITTA';
export const TYPE_VATA = 'VATA';
